<template>
  <div class="split-box bg-white p-4 shadow-theme rounded-small" :style="boxStyle">
    <slot name="top-content"></slot>
    <div class="line my-4" :style="lineStyle"></div>
    <slot name="bottom-content"></slot>
  </div>
</template>

<script>
export default {
  name: 'SplitBox',
  props: {
    bgColor: {
      type: String,
      default: ''
    },
    lineColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    boxStyle() {
      const res = {}
      if (this.bgColor) {
        res.backgroundColor = this.bgColor
      }
      return res
    },
    lineStyle() {
      if (!this.lineColor) {
        return {}
      }
      return {
        borderColor: this.lineColor
      }
    }
  }
}
</script>

<style scoped lang="scss">
$--end-bg-color: #f0f2f5;
.split-box {
  .line {
    border-bottom: 2px dashed #e7e9eb;
    position: relative;

    &::before,
    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: $--end-bg-color;
    }

    &::before {
      left: -24px;
    }

    &::after {
      right: -24px;
    }
  }
}
</style>
